module.exports = __webpack_public_path__ + "static/img/m_global_flow_step3@3x.6ffbeb7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/m_global_flow_step3@3x.png
// module id = IYti
// module chunks = 1